import Basket from "@/Controller/Basket";
window.app = new Basket;
